import { Project } from "../models/project";
import { Sprint } from "../models/sprint";
import { Status } from "../models/status";
import { Task } from "../models/task";
import { IUserInfo, UserInfo } from "../models/userInfo";

export const compareArray = (a: any[], b: any[]) => {
    if (a.length != b.length) {
        return a.length - b.length;
    }
    let count = 0;
    for (let i of a) {
        if (b.includes(i)) count++;
    }
    return count - a.length;
};

export const getUserFromJson = (data: any): IUserInfo | undefined => {
    if (data) {
        let name = "";
        try {
            name = data.constructor.name;
        } catch (e) {}
        if (name === "UserInfo" || name === "IUserInfo") {
            return data;
        }
        if (name === "Array") {
            if (!data[0]) {
                return undefined;
            }
            return new UserInfo(data[0]);
        }
        if (name === "Object") {
            return new UserInfo(data);
        }
        if (typeof data === "object") {
            return new UserInfo(data);
        }
        if (data[0] && typeof data[0] === "object") {
            return new UserInfo(data[0]);
        }
    }
    return;
};

export const getProjectFromJson = (data: any): Project | undefined => {
    if (data) {
        let name = "";
        try {
            name = data.constructor.name;
        } catch (e) {}
        if (name === "Project" || name === "IProject") {
            return data;
        }
        if (name === "Array") {
            if (!data[0]) {
                return undefined;
            }
            return new Project(data[0]);
        }
        if (name === "Object") {
            return new Project(data);
        }
        if (typeof data === "object") {
            return new Project(data);
        }
        if (data[0] && typeof data[0] === "object") {
            return new Project(data[0]);
        }
    }
    return;
};

export const getSprintFromJson = (data: any): Sprint | undefined => {
    if (data) {
        let name = "";
        try {
            name = data.constructor.name;
        } catch (e) {}
        if (name === "Sprint" || name === "ISprint") {
            return data;
        }
        if (name === "Array") {
            if (!data[0]) {
                return undefined;
            }
            return new Sprint(data[0]);
        }
        if (name === "Object") {
            return new Sprint(data);
        }
        if (typeof data === "object") {
            return new Sprint(data);
        }
        if (data[0] && typeof data[0] === "object") {
            return new Sprint(data[0]);
        }
    }
    return;
};

export const getStatusFromJson = (data: any): Status | undefined => {
    if (data) {
        let name = "";
        try {
            name = data.constructor.name;
        } catch (e) {}
        if (name === "Status" || name === "IStatus") {
            return data;
        }
        if (name === "Array") {
            if (!data[0]) {
                return undefined;
            }
            return new Status(data[0]);
        }
        if (name === "Object") {
            return new Status(data);
        }
        if (typeof data === "object") {
            return new Status(data);
        }
        if (data[0] && typeof data[0] === "object") {
            return new Status(data[0]);
        }
    }
    return;
};

export const getTaskFromJson = (data: any): Task | undefined => {
    if (data) {
        let name = "";
        try {
            name = data.constructor.name;
        } catch (e) {}
        if (name === "Status" || name === "IStatus") {
            return data;
        }
        if (name === "Array" && data[0]) {
            return new Task(data[0]);
        }
        if (name === "Object") {
            return new Task(data);
        }
        if (typeof data === "object") {
            return new Task(data);
        }
        if (data[0] && typeof data[0] === "object") {
            return new Task(data[0]);
        }
    }
    return;
};

export function convertToJSONObject(model: any) {
    return JSON.parse(JSON.stringify(model));
}

export interface OrganizationInfo {
    id: number;
    name: string;
    organization: string[];
}

export const getOrganizationInfo = (): Map<string, OrganizationInfo> => {
    const map = new Map<string, OrganizationInfo>();
    map.set("61ebb0a21d081e33539091fd", {
        id: map.size,
        name: "App",
        organization: ["abc-elearning-app"],
    });
    map.set("61ebb0941d081e33539091f0", {
        id: map.size,
        name: "Web",
        organization: ["super-web-app"],
    });
    map.set("61ebb0a91d081e335390920b", {
        id: map.size,
        name: "Operation",
        organization: ["abc-hero"],
    });
    map.set("61ebb0b21d081e3353909219", {
        id: map.size,
        name: "Worksheet",
        organization: [],
    });
    map.set("61ebb0cf1d081e335390923d", {
        id: map.size,
        name: "TestHub",
        organization: [],
    });
    map.set("6272bbec8adfec3d1e7f81e8", {
        id: map.size,
        name: "Dashboard",
        organization: [],
    });
    return map;
};

export const getOrganizationWithProjectId = (projectId: string): string[] => {
    const map = getOrganizationInfo();
    return map.get(projectId)?.organization ?? [];
};
